import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';

export interface JourneyPlannerLocationMark {
    origin: string;
    destination: string;
    id: number | string;
}

interface JourneyPlannerMunicipality {
    origin: string;
    destination: string;
}

const TRANSLATION_MAP = {
    LOCATION_FROM_MAP: 'LOCATION_FROM_MAP',
    CURRENT_LOCATION: 'CURRENT_LOCATION'
};

@Component({
    selector: 'rwidget-journey-planner-location-mark',
    templateUrl: './journey-planner-location-mark.component.html',
    styleUrls: ['./journey-planner-location-mark.component.scss']
})
export class JourneyPlannerLocationMarkComponent {
    public readonly TRANSLATION_MAP = TRANSLATION_MAP;
    @Input() location: JourneyPlannerLocationMark | JourneyPlannerMunicipality;

    @Input() isShowRemoveIcon = true;

    @Input() municipalityName: JourneyPlannerMunicipality;

    @Output()
    public clickOnLocation: EventEmitter<JourneyPlannerLocationMark | JourneyPlannerMunicipality> = new EventEmitter();

    @Output()
    public clickOnRemoveIcon: EventEmitter<JourneyPlannerLocationMark | JourneyPlannerMunicipality> =
        new EventEmitter();

    public assetsPath$ = this.applicationFacade.assetsPath$;
    public readonly useTrashIcon: boolean;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {
        this.useTrashIcon = this.env.JOURNEY_PLANNER?.USE_TRASH_BIN_FOR_REMOVE_FAVORITE_STOP === true;
    }

    public handleClick(): void {
        this.clickOnLocation.emit(this.location);
    }

    public handleRemove(event): void {
        event.stopPropagation();
        event.preventDefault();
        this.clickOnRemoveIcon.emit(this.location);
    }
}
